import { Route } from '@angular/router'
import { authGuard, permissionGuard } from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type ClientRoutes = {
    clients: Route
    homeClient: Route
    clientDetails: Route
    clientBookAppointment: Route
    browseShops: Route
    shopProfile: Route
    myAppointments: Route
    favoriteShops: Route
    offers: Route
    hairstyles: Route
    reviews: Route
}

export const clientRoutes: ClientRoutes = {
    clients: {
        path: 'dashboard/clients',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.crm.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-clients/page-clients.component').then(
                (m) => m.PageClientsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    homeClient: {
        path: 'dashboard/home/client',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('../page-home-client/page-home-client.component').then(
                (m) => m.PageHomeClientComponent,
            ),
        resolve: { layout: setLayout(PageLayout.ClientDefault) },
    },

    clientDetails: {
        path: 'dashboard/clients/:id',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.crm.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-client/page-client.component').then(
                (m) => m.PageClientComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },

    clientBookAppointment: {
        path: 'dashboard/client/book-appointment',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('./page-book-appointment/page-book-appointment.component').then(
                (m) => m.PageClientBookAppointmentComponent,
            ),
        resolve: { layout: setLayout(PageLayout.ClientDefault) },
    },

    browseShops: {
        path: 'dashboard/client/shops',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('./page-browse-shops/page-browse-shops.component').then(
                (m) => m.PageClientBrowseShopsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.ClientDefault) },
    },

    shopProfile: {
        path: 'dashboard/client/shops/:id',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('./page-shop-profile/page-shop-profile.component').then(
                (m) => m.PageClientShopProfileComponent,
            ),
        resolve: { layout: setLayout(PageLayout.ClientDefault) },
    },

    myAppointments: {
        path: 'dashboard/client/my-appointments',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('./page-my-appointments/page-my-appointments.component').then(
                (m) => m.PageClientMyAppointmentsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.ClientDefault) },
    },
    favoriteShops: {
        path: 'dashboard/client/favorites',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('./page-favorite-shops/page-favorite-shops.component').then(
                (m) => m.PageFavoriteShopsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.ClientDefault) },
    },
    offers: {
        path: 'dashboard/client/offers',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('./page-offers/page-offers.component').then(
                (m) => m.PageOffersComponent,
            ),
        resolve: { layout: setLayout(PageLayout.ClientDefault) },
    },
    hairstyles: {
        path: 'dashboard/client/hairstyles',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('./page-my-hairstyles/page-my-hairstyles.component').then(
                (m) => m.PageMyHairstylesComponent,
            ),
        resolve: { layout: setLayout(PageLayout.ClientDefault) },
    },
    reviews: {
        path: 'dashboard/client/reviews',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('./page-my-reviews/page-my-reviews.component').then(
                (m) => m.PageMyReviewsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.ClientDefault) },
    },
}
